var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#EFB914"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8136 5.54344C12.2847 5.91304 12.6767 6.37351 12.9664 6.89752C13.2561 7.42153 13.4375 7.99839 13.5 8.59387L11.8986 8.19562C11.7479 7.69237 11.4682 7.23727 11.0873 6.87545C10.7065 6.51362 10.2376 6.25766 9.72731 6.13294C8.11518 5.73187 6.48731 6.69037 6.09075 8.27381C5.69419 9.85725 6.68137 11.466 8.29406 11.8671C8.8038 11.9957 9.3383 11.9892 9.84476 11.8482C10.3512 11.7071 10.8121 11.4364 11.1819 11.0627L12.7834 11.4604C12.4478 11.9571 12.0161 12.3815 11.5137 12.7086C11.0113 13.0356 10.4484 13.2586 9.85837 13.3644L9.40275 15.1875L7.9425 14.8247L8.30475 13.3763C8.05687 13.3355 7.8127 13.2747 7.57462 13.1946L7.21294 14.643L5.75269 14.2796L6.20831 12.4566C4.87068 11.4019 4.19737 9.64631 4.63106 7.911C5.06475 6.17569 6.48562 4.94044 8.16356 4.63556L8.61918 2.8125L10.0794 3.17531L9.71719 4.62375C9.96506 4.66452 10.2092 4.72528 10.4473 4.80544L10.809 3.357L12.2692 3.72037L11.8136 5.54344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.7cf03cf8332c7aa4dc4c01684bd02b91.svg";
export { ForwardRef as ReactComponent };